import * as React from 'react';

import { TranslationString } from 'shared/entities/localization';

import { ReferenceProps } from './Reference';

export type BaseModalProps = {
  opened: boolean;
  onClose: () => void;
  dismissible?: boolean;
  closeOnEscape?: boolean;
  /** Имя диалога, когда шапки с заголовком нет */
  ariaLabel?: string;
  ariaLabelledBy?: string;
  initialFocusRef?: React.RefObject<HTMLElement>;
  fullScreenMobile?: boolean;
};

export enum ModalSize {
  xs = 'xs',
  s = 's',
  sm = 'sm',
  m = 'm',
  l = 'l'
}

export type ContentModalProps = React.PropsWithChildren<
  BaseModalProps & {
    title?: TranslationString | React.ReactNode;
    /** Вторая строка шапки, под заголовком и на всю ширину */
    subTitle?: TranslationString | string;
    /** Доступ к заголовку для программного переноса фокуса */
    titleRef?: React.RefObject<HTMLHeadingElement>;
    headerExtraComponent?: React.ReactNode;
    headerRightComponent?: React.ReactNode;
    headerLeftComponent?: React.ReactNode;
    fixHeight?: boolean;
    fullScreen?: boolean;
    className?: string;
    contentClassName?: string;
    size?: ModalSize;
    reference?: ReferenceProps;
    style?: React.CSSProperties;
    withHeader?: boolean;
  }
>;
